const region = "us-east-1";

const prod = {
	appSettingsData: {
		BuyerCognitoGroup: "wl-pd-procurement-portal-buyers",
		SupplierCognitoGroup: "wl-pd-procurement-portal-suppliers",
		federatedIDPProvider: "wl-pd-procurement-portal-idp"
	},
	amplify_config: {
		Auth: {
			Cognito: {
				userPoolId: "us-east-1_W6LgPX3ub",
				userPoolClientId: "7uvgo0aajf73sh9qh6ftdtobg0",
				loginWith: {
					oauth: {
						domain: "wl-procurement-portal.auth.us-east-1.amazoncognito.com",
						scopes: [],
						redirectSignIn: [
							"https://wl-procurement-portal.com/login",
							"http://localhost:3000/login"
						],
						redirectSignOut: [
							"https://wl-procurement-portal.com/login",
							"http://localhost:3000/login"
						],
						responseType: "code"
					}
				}
			}
		},
		API: {
			REST: {
				print: {
					endpoint: "https://api.wl-procurement-portal.com/print",
					region: region
				}
			}
		}
	}
};



export default prod;
